<template>
  <svg version="1.1" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none" width="177.103px" height="80px" viewBox="0 0 177.103 80"
    enable-background="new 0 0 177.103 80" xml:space="preserve">
    <title>{{ hint }}</title>
    <defs>
      <linearGradient id="SCND_SVGID_1_" gradientUnits="userSpaceOnUse" x1="138.4175" y1="8.5781" x2="154.4714"
        y2="8.5781">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_2_" gradientUnits="userSpaceOnUse" x1="3.3906" y1="66.0996" x2="7.1074"
        y2="66.0996">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_3_" gradientUnits="userSpaceOnUse" x1="16.9688" y1="66.0996" x2="20.6855"
        y2="66.0996">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_4_" gradientUnits="userSpaceOnUse" x1="47.2686" y1="66.0996" x2="50.9854"
        y2="66.0996">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_5_" gradientUnits="userSpaceOnUse" x1="27.4771" y1="24.5869" x2="27.477"
        y2="64.5872">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_6_" gradientUnits="userSpaceOnUse" x1="34.1167" y1="57.3706" x2="32.6732"
        y2="21.5727">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_7_" gradientUnits="userSpaceOnUse" x1="33.8877" y1="57.1157" x2="32.4442"
        y2="21.3179">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_8_" gradientUnits="userSpaceOnUse" x1="33.6582" y1="56.8584" x2="32.2147"
        y2="21.0605">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_9_" gradientUnits="userSpaceOnUse" x1="33.4287" y1="56.5991" x2="31.9856"
        y2="20.8104">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_10_" gradientUnits="userSpaceOnUse" x1="33.1997" y1="56.3462" x2="31.7562"
        y2="20.5483">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_11_" gradientUnits="userSpaceOnUse" x1="32.9707" y1="56.0908" x2="31.527"
        y2="20.2884">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_12_" gradientUnits="userSpaceOnUse" x1="32.7417" y1="55.834" x2="31.2984"
        y2="20.0407">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_13_" gradientUnits="userSpaceOnUse" x1="32.5122" y1="55.5771" x2="31.0685"
        y2="19.7747">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_14_" gradientUnits="userSpaceOnUse" x1="20.2168" y1="43.2466" x2="80.8122"
        y2="94.5446">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_15_" gradientUnits="userSpaceOnUse" x1="48.1704" y1="80.4473" x2="-7.6107"
        y2="-5.7924">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_16_" gradientUnits="userSpaceOnUse" x1="112.5215" y1="54.9541" x2="112.5215"
        y2="19.4495">
        <stop offset="0.0714" style="stop-color: #bababa" />
        <stop offset="0.3137" style="stop-color: #bbbbbb" />
        <stop offset="0.401" style="stop-color: #bfbfbf" />
        <stop offset="0.4632" style="stop-color: #c6c6c6" />
        <stop offset="0.5134" style="stop-color: #d0d0d0" />
        <stop offset="0.556" style="stop-color: #dcdcdc" />
        <stop offset="0.5714" style="stop-color: #e2e2e2" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_17_" gradientUnits="userSpaceOnUse" x1="146.5127" y1="70.918" x2="146.5127"
        y2="11.4681">
        <stop offset="0.1319" style="stop-color: #606060" />
        <stop offset="0.2537" style="stop-color: #626262" />
        <stop offset="0.2975" style="stop-color: #686868" />
        <stop offset="0.3286" style="stop-color: #737373" />
        <stop offset="0.3352" style="stop-color: #767676" />
        <stop offset="0.5178" style="stop-color: #787878" />
        <stop offset="0.5836" style="stop-color: #7e7e7e" />
        <stop offset="0.6305" style="stop-color: #8a8a8a" />
        <stop offset="0.6684" style="stop-color: #9a9a9a" />
        <stop offset="0.7005" style="stop-color: #afafaf" />
        <stop offset="0.7143" style="stop-color: #bababa" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_18_" gradientUnits="userSpaceOnUse" x1="82.9678" y1="46.4229" x2="83.9817"
        y2="88.4992">
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="1" style="stop-color: #e2e2e2" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_19_" gradientUnits="userSpaceOnUse" x1="75.5024" y1="67.8892" x2="75.5024"
        y2="8.164">
        <stop offset="0.0714" style="stop-color: #bababa" />
        <stop offset="0.3563" style="stop-color: #bbbbbb" />
        <stop offset="0.4589" style="stop-color: #bfbfbf" />
        <stop offset="0.532" style="stop-color: #c6c6c6" />
        <stop offset="0.5912" style="stop-color: #d0d0d0" />
        <stop offset="0.6412" style="stop-color: #dcdcdc" />
        <stop offset="0.6593" style="stop-color: #e2e2e2" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_20_" gradientUnits="userSpaceOnUse" x1="99.8574" y1="54.9692" x2="173.0071"
        y2="116.8952">
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="1" style="stop-color: #e2e2e2" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_21_" gradientUnits="userSpaceOnUse" x1="97.4697" y1="55.3691" x2="174.5354"
        y2="106.0122">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_22_" gradientUnits="userSpaceOnUse" x1="160.9624" y1="23.8525" x2="160.9624"
        y2="50.8252">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_23_" gradientUnits="userSpaceOnUse" x1="164.9541" y1="26.606" x2="164.9541"
        y2="48.2567">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_24_" gradientUnits="userSpaceOnUse" x1="169.269" y1="27.3389" x2="169.269"
        y2="47.3389">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_25_" gradientUnits="userSpaceOnUse" x1="174.4912" y1="24.3389" x2="174.4912"
        y2="50.3389">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>
      <linearGradient id="SCND_SVGID_26_" gradientUnits="userSpaceOnUse" x1="135.7168" y1="2.2939" x2="157.2186"
        y2="2.2939">
        <stop offset="0" style="stop-color: #606060" />
        <stop offset="0.1011" style="stop-color: #646464" />
        <stop offset="0.2113" style="stop-color: #707070" />
        <stop offset="0.25" style="stop-color: #767676" />
        <stop offset="0.5" style="stop-color: #bababa" />
        <stop offset="0.75" style="stop-color: #767676" />
        <stop offset="0.7981" style="stop-color: #6e6e6e" />
        <stop offset="0.8972" style="stop-color: #646464" />
        <stop offset="1" style="stop-color: #606060" />
      </linearGradient>

      <linearGradient id="red_1_" gradientUnits="userSpaceOnUse" x1="138.4175" y1="8.5781" x2="154.4714" y2="8.5781">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_2_" gradientUnits="userSpaceOnUse" x1="3.3906" y1="66.0996" x2="7.1074" y2="66.0996">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_3_" gradientUnits="userSpaceOnUse" x1="16.9688" y1="66.0996" x2="20.6855" y2="66.0996">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_4_" gradientUnits="userSpaceOnUse" x1="47.2686" y1="66.0996" x2="50.9854" y2="66.0996">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_5_" gradientUnits="userSpaceOnUse" x1="27.4771" y1="24.5869" x2="27.477" y2="64.5872">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_6_" gradientUnits="userSpaceOnUse" x1="34.1167" y1="57.3706" x2="32.6732" y2="21.5727">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_7_" gradientUnits="userSpaceOnUse" x1="33.8877" y1="57.1157" x2="32.4442" y2="21.3179">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_8_" gradientUnits="userSpaceOnUse" x1="33.6582" y1="56.8584" x2="32.2147" y2="21.0605">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_9_" gradientUnits="userSpaceOnUse" x1="33.4287" y1="56.5991" x2="31.9856" y2="20.8104">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_10_" gradientUnits="userSpaceOnUse" x1="33.1997" y1="56.3462" x2="31.7562" y2="20.5483">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_11_" gradientUnits="userSpaceOnUse" x1="32.9707" y1="56.0908" x2="31.527" y2="20.2884">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_12_" gradientUnits="userSpaceOnUse" x1="32.7417" y1="55.834" x2="31.2984" y2="20.0407">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_13_" gradientUnits="userSpaceOnUse" x1="32.5122" y1="55.5771" x2="31.0685" y2="19.7747">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_14_" gradientUnits="userSpaceOnUse" x1="20.2168" y1="43.2466" x2="80.8122" y2="94.5446">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_15_" gradientUnits="userSpaceOnUse" x1="48.1704" y1="80.4473" x2="-7.6107" y2="-5.7924">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_16_" gradientUnits="userSpaceOnUse" x1="112.5215" y1="54.9541" x2="112.5215" y2="19.4495">
        <stop offset="0.0714" style="stop-color: #ba0000" />
        <stop offset="0.3137" style="stop-color: #bb0000" />
        <stop offset="0.401" style="stop-color: #bf0000" />
        <stop offset="0.4632" style="stop-color: #c60000" />
        <stop offset="0.5134" style="stop-color: #d00000" />
        <stop offset="0.556" style="stop-color: #dc0000" />
        <stop offset="0.5714" style="stop-color: #e20000" />
      </linearGradient>
      <linearGradient id="red_17_" gradientUnits="userSpaceOnUse" x1="146.5127" y1="70.918" x2="146.5127" y2="11.4681">
        <stop offset="0.1319" style="stop-color: #600000" />
        <stop offset="0.2537" style="stop-color: #620000" />
        <stop offset="0.2975" style="stop-color: #680000" />
        <stop offset="0.3286" style="stop-color: #730000" />
        <stop offset="0.3352" style="stop-color: #760000" />
        <stop offset="0.5178" style="stop-color: #780000" />
        <stop offset="0.5836" style="stop-color: #7e0000" />
        <stop offset="0.6305" style="stop-color: #8a0000" />
        <stop offset="0.6684" style="stop-color: #9a0000" />
        <stop offset="0.7005" style="stop-color: #af0000" />
        <stop offset="0.7143" style="stop-color: #ba0000" />
      </linearGradient>
      <linearGradient id="red_18_" gradientUnits="userSpaceOnUse" x1="82.9678" y1="46.4229" x2="83.9817" y2="88.4992">
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="1" style="stop-color: #e20000" />
      </linearGradient>
      <linearGradient id="red_19_" gradientUnits="userSpaceOnUse" x1="75.5024" y1="67.8892" x2="75.5024" y2="8.164">
        <stop offset="0.0714" style="stop-color: #ba0000" />
        <stop offset="0.3563" style="stop-color: #bb0000" />
        <stop offset="0.4589" style="stop-color: #bf0000" />
        <stop offset="0.532" style="stop-color: #c60000" />
        <stop offset="0.5912" style="stop-color: #d00000" />
        <stop offset="0.6412" style="stop-color: #dc0000" />
        <stop offset="0.6593" style="stop-color: #e20000" />
      </linearGradient>
      <linearGradient id="red_20_" gradientUnits="userSpaceOnUse" x1="99.8574" y1="54.9692" x2="173.0071" y2="116.8952">
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="1" style="stop-color: #e20000" />
      </linearGradient>
      <linearGradient id="red_21_" gradientUnits="userSpaceOnUse" x1="97.4697" y1="55.3691" x2="174.5354" y2="106.0122">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_22_" gradientUnits="userSpaceOnUse" x1="160.9624" y1="23.8525" x2="160.9624" y2="50.8252">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_23_" gradientUnits="userSpaceOnUse" x1="164.9541" y1="26.606" x2="164.9541" y2="48.2567">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_24_" gradientUnits="userSpaceOnUse" x1="169.269" y1="27.3389" x2="169.269" y2="47.3389">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_25_" gradientUnits="userSpaceOnUse" x1="174.4912" y1="24.3389" x2="174.4912" y2="50.3389">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>
      <linearGradient id="red_26_" gradientUnits="userSpaceOnUse" x1="135.7168" y1="2.2939" x2="157.2186" y2="2.2939">
        <stop offset="0" style="stop-color: #600000" />
        <stop offset="0.1011" style="stop-color: #640000" />
        <stop offset="0.2113" style="stop-color: #700000" />
        <stop offset="0.25" style="stop-color: #760000" />
        <stop offset="0.5" style="stop-color: #ba0000" />
        <stop offset="0.75" style="stop-color: #760000" />
        <stop offset="0.7981" style="stop-color: #6e0000" />
        <stop offset="0.8972" style="stop-color: #640000" />
        <stop offset="1" style="stop-color: #600000" />
      </linearGradient>

      <linearGradient id="green_1_" gradientUnits="userSpaceOnUse" x1="138.4175" y1="8.5781" x2="154.4714" y2="8.5781">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_2_" gradientUnits="userSpaceOnUse" x1="3.3906" y1="66.0996" x2="7.1074" y2="66.0996">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_3_" gradientUnits="userSpaceOnUse" x1="16.9688" y1="66.0996" x2="20.6855" y2="66.0996">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_4_" gradientUnits="userSpaceOnUse" x1="47.2686" y1="66.0996" x2="50.9854" y2="66.0996">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_5_" gradientUnits="userSpaceOnUse" x1="27.4771" y1="24.5869" x2="27.477" y2="64.5872">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_6_" gradientUnits="userSpaceOnUse" x1="34.1167" y1="57.3706" x2="32.6732" y2="21.5727">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_7_" gradientUnits="userSpaceOnUse" x1="33.8877" y1="57.1157" x2="32.4442" y2="21.3179">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_8_" gradientUnits="userSpaceOnUse" x1="33.6582" y1="56.8584" x2="32.2147" y2="21.0605">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_9_" gradientUnits="userSpaceOnUse" x1="33.4287" y1="56.5991" x2="31.9856" y2="20.8104">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_10_" gradientUnits="userSpaceOnUse" x1="33.1997" y1="56.3462" x2="31.7562" y2="20.5483">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_11_" gradientUnits="userSpaceOnUse" x1="32.9707" y1="56.0908" x2="31.527" y2="20.2884">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_12_" gradientUnits="userSpaceOnUse" x1="32.7417" y1="55.834" x2="31.2984" y2="20.0407">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_13_" gradientUnits="userSpaceOnUse" x1="32.5122" y1="55.5771" x2="31.0685" y2="19.7747">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_14_" gradientUnits="userSpaceOnUse" x1="20.2168" y1="43.2466" x2="80.8122" y2="94.5446">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_15_" gradientUnits="userSpaceOnUse" x1="48.1704" y1="80.4473" x2="-7.6107" y2="-5.7924">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_16_" gradientUnits="userSpaceOnUse" x1="112.5215" y1="54.9541" x2="112.5215"
        y2="19.4495">
        <stop offset="0.0714" style="stop-color: #80b080" />
        <stop offset="0.3137" style="stop-color: #88b888" />
        <stop offset="0.401" style="stop-color: #90c090" />
        <stop offset="0.4632" style="stop-color: #98c898" />
        <stop offset="0.5134" style="stop-color: #a0d0a0" />
        <stop offset="0.556" style="stop-color: #b0e0b0" />
        <stop offset="0.5714" style="stop-color: #c0f0c0" />
      </linearGradient>
      <linearGradient id="green_17_" gradientUnits="userSpaceOnUse" x1="146.5127" y1="70.918" x2="146.5127"
        y2="11.4681">
        <stop offset="0.1319" style="stop-color: #408040" />
        <stop offset="0.2537" style="stop-color: #428242" />
        <stop offset="0.2975" style="stop-color: #488848" />
        <stop offset="0.3286" style="stop-color: #539353" />
        <stop offset="0.3352" style="stop-color: #569656" />
        <stop offset="0.5178" style="stop-color: #589858" />
        <stop offset="0.5836" style="stop-color: #5e9e5e" />
        <stop offset="0.6305" style="stop-color: #6aae6a" />
        <stop offset="0.6684" style="stop-color: #7abe7a" />
        <stop offset="0.7005" style="stop-color: #8fca8f" />
        <stop offset="0.7143" style="stop-color: #80b080" />
      </linearGradient>
      <linearGradient id="green_18_" gradientUnits="userSpaceOnUse" x1="82.9678" y1="46.4229" x2="83.9817" y2="88.4992">
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="1" style="stop-color: #c0f0c0" />
      </linearGradient>
      <linearGradient id="green_19_" gradientUnits="userSpaceOnUse" x1="75.5024" y1="67.8892" x2="75.5024" y2="8.164">
        <stop offset="0.0714" style="stop-color: #80b080" />
        <stop offset="0.3563" style="stop-color: #88b888" />
        <stop offset="0.4589" style="stop-color: #90c090" />
        <stop offset="0.532" style="stop-color: #98c898" />
        <stop offset="0.5912" style="stop-color: #a0d0a0" />
        <stop offset="0.6412" style="stop-color: #b0e0b0" />
        <stop offset="0.6593" style="stop-color: #c0f0c0" />
      </linearGradient>
      <linearGradient id="green_20_" gradientUnits="userSpaceOnUse" x1="99.8574" y1="54.9692" x2="173.0071"
        y2="116.8952">
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="1" style="stop-color: #c0f0c0" />
      </linearGradient>
      <linearGradient id="green_21_" gradientUnits="userSpaceOnUse" x1="97.4697" y1="55.3691" x2="174.5354"
        y2="106.0122">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_22_" gradientUnits="userSpaceOnUse" x1="160.9624" y1="23.8525" x2="160.9624"
        y2="50.8252">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_23_" gradientUnits="userSpaceOnUse" x1="164.9541" y1="26.606" x2="164.9541"
        y2="48.2567">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_24_" gradientUnits="userSpaceOnUse" x1="169.269" y1="27.3389" x2="169.269" y2="47.3389">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_25_" gradientUnits="userSpaceOnUse" x1="174.4912" y1="24.3389" x2="174.4912"
        y2="50.3389">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>
      <linearGradient id="green_26_" gradientUnits="userSpaceOnUse" x1="135.7168" y1="2.2939" x2="157.2186" y2="2.2939">
        <stop offset="0" style="stop-color: #408040" />
        <stop offset="0.1011" style="stop-color: #448844" />
        <stop offset="0.2113" style="stop-color: #509050" />
        <stop offset="0.25" style="stop-color: #569657" />
        <stop offset="0.5" style="stop-color: #80b080" />
        <stop offset="0.75" style="stop-color: #569657" />
        <stop offset="0.7981" style="stop-color: #4d8e4e" />
        <stop offset="0.8972" style="stop-color: #448844" />
        <stop offset="1" style="stop-color: #408040" />
      </linearGradient>

      <linearGradient id="yellow_1_" gradientUnits="userSpaceOnUse" x1="138.4175" y1="8.5781" x2="154.4714" y2="8.5781">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_2_" gradientUnits="userSpaceOnUse" x1="3.3906" y1="66.0996" x2="7.1074" y2="66.0996">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_3_" gradientUnits="userSpaceOnUse" x1="16.9688" y1="66.0996" x2="20.6855" y2="66.0996">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_4_" gradientUnits="userSpaceOnUse" x1="47.2686" y1="66.0996" x2="50.9854" y2="66.0996">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_5_" gradientUnits="userSpaceOnUse" x1="27.4771" y1="24.5869" x2="27.477" y2="64.5872">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_6_" gradientUnits="userSpaceOnUse" x1="34.1167" y1="57.3706" x2="32.6732" y2="21.5727">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_7_" gradientUnits="userSpaceOnUse" x1="33.8877" y1="57.1157" x2="32.4442" y2="21.3179">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_8_" gradientUnits="userSpaceOnUse" x1="33.6582" y1="56.8584" x2="32.2147" y2="21.0605">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_9_" gradientUnits="userSpaceOnUse" x1="33.4287" y1="56.5991" x2="31.9856" y2="20.8104">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_10_" gradientUnits="userSpaceOnUse" x1="33.1997" y1="56.3462" x2="31.7562"
        y2="20.5483">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_11_" gradientUnits="userSpaceOnUse" x1="32.9707" y1="56.0908" x2="31.527" y2="20.2884">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_12_" gradientUnits="userSpaceOnUse" x1="32.7417" y1="55.834" x2="31.2984" y2="20.0407">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_13_" gradientUnits="userSpaceOnUse" x1="32.5122" y1="55.5771" x2="31.0685"
        y2="19.7747">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_14_" gradientUnits="userSpaceOnUse" x1="20.2168" y1="43.2466" x2="80.8122"
        y2="94.5446">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_15_" gradientUnits="userSpaceOnUse" x1="48.1704" y1="80.4473" x2="-7.6107"
        y2="-5.7924">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_16_" gradientUnits="userSpaceOnUse" x1="112.5215" y1="54.9541" x2="112.5215"
        y2="19.4495">
        <stop offset="0.0714" style="stop-color: #baba00" />
        <stop offset="0.3137" style="stop-color: #bbbb00" />
        <stop offset="0.401" style="stop-color: #bfbf00" />
        <stop offset="0.4632" style="stop-color: #c6c600" />
        <stop offset="0.5134" style="stop-color: #d0d000" />
        <stop offset="0.556" style="stop-color: #dcdc00" />
        <stop offset="0.5714" style="stop-color: #e2e200" />
      </linearGradient>
      <linearGradient id="yellow_17_" gradientUnits="userSpaceOnUse" x1="146.5127" y1="70.918" x2="146.5127"
        y2="11.4681">
        <stop offset="0.1319" style="stop-color: #606000" />
        <stop offset="0.2537" style="stop-color: #626200" />
        <stop offset="0.2975" style="stop-color: #686800" />
        <stop offset="0.3286" style="stop-color: #737300" />
        <stop offset="0.3352" style="stop-color: #767600" />
        <stop offset="0.5178" style="stop-color: #787800" />
        <stop offset="0.5836" style="stop-color: #7e7e00" />
        <stop offset="0.6305" style="stop-color: #8a8a00" />
        <stop offset="0.6684" style="stop-color: #9a9a00" />
        <stop offset="0.7005" style="stop-color: #afaf00" />
        <stop offset="0.7143" style="stop-color: #baba00" />
      </linearGradient>
      <linearGradient id="yellow_18_" gradientUnits="userSpaceOnUse" x1="82.9678" y1="46.4229" x2="83.9817"
        y2="88.4992">
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="1" style="stop-color: #e2e200" />
      </linearGradient>
      <linearGradient id="yellow_19_" gradientUnits="userSpaceOnUse" x1="75.5024" y1="67.8892" x2="75.5024" y2="8.164">
        <stop offset="0.0714" style="stop-color: #baba00" />
        <stop offset="0.3563" style="stop-color: #bbbb00" />
        <stop offset="0.4589" style="stop-color: #bfbf00" />
        <stop offset="0.532" style="stop-color: #c6c600" />
        <stop offset="0.5912" style="stop-color: #d0d000" />
        <stop offset="0.6412" style="stop-color: #dcdc00" />
        <stop offset="0.6593" style="stop-color: #e2e200" />
      </linearGradient>
      <linearGradient id="yellow_20_" gradientUnits="userSpaceOnUse" x1="99.8574" y1="54.9692" x2="173.0071"
        y2="116.8952">
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="1" style="stop-color: #e2e200" />
      </linearGradient>
      <linearGradient id="yellow_21_" gradientUnits="userSpaceOnUse" x1="97.4697" y1="55.3691" x2="174.5354"
        y2="106.0122">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_22_" gradientUnits="userSpaceOnUse" x1="160.9624" y1="23.8525" x2="160.9624"
        y2="50.8252">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_23_" gradientUnits="userSpaceOnUse" x1="164.9541" y1="26.606" x2="164.9541"
        y2="48.2567">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_24_" gradientUnits="userSpaceOnUse" x1="169.269" y1="27.3389" x2="169.269"
        y2="47.3389">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_25_" gradientUnits="userSpaceOnUse" x1="174.4912" y1="24.3389" x2="174.4912"
        y2="50.3389">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>
      <linearGradient id="yellow_26_" gradientUnits="userSpaceOnUse" x1="135.7168" y1="2.2939" x2="157.2186"
        y2="2.2939">
        <stop offset="0" style="stop-color: #606000" />
        <stop offset="0.1011" style="stop-color: #646400" />
        <stop offset="0.2113" style="stop-color: #707000" />
        <stop offset="0.25" style="stop-color: #767600" />
        <stop offset="0.5" style="stop-color: #baba00" />
        <stop offset="0.75" style="stop-color: #767600" />
        <stop offset="0.7981" style="stop-color: #6e6e00" />
        <stop offset="0.8972" style="stop-color: #646400" />
        <stop offset="1" style="stop-color: #606000" />
      </linearGradient>

      <rect id="main_1" x="136.376" y="3.745" width="20" height="9.666" />
      <rect id="main_2" x="3.391" y="60.272" width="3.717" height="11.654" />
      <rect id="main_3" x="16.969" y="60.272" width="3.717" height="11.654" />
      <rect id="main_4" x="47.269" y="60.272" width="3.717" height="11.654" />
      <path id="main_5" d="M54.954,57.981c0,3.039-2.004,5.505-5.045,5.505H5.505C2.464,63.486,0,61.021,0,57.981v-27.89
							c0-3.041,2.464-5.505,5.505-5.505h44.404c3.041,0,5.045,2.464,5.045,5.505V57.981z" />
      <rect id="scnd_5" x="12.844" y="24.587" width="39.22" height="38.899" />
      <rect id="main_6" x="12.844" y="23.302" width="39.887" height="2.202" />
      <rect id="main_7" x="12.844" y="28.729" width="39.887" height="2.202" />
      <rect id="main_8" x="12.844" y="34.153" width="39.887" height="2.202" />
      <rect id="main_9" x="12.844" y="39.581" width="39.887" height="2.201" />
      <rect id="main_10" x="12.844" y="45.006" width="39.887" height="2.202" />
      <rect id="main_11" x="12.844" y="50.432" width="39.887" height="2.202" />
      <rect id="main_12" x="12.844" y="55.858" width="39.887" height="2.201" />
      <rect id="main_13" x="12.844" y="61.284" width="39.887" height="2.202" />
      <rect id="scnd_6" x="54.954" y="28.992" width="4.447" height="30.639" />
      <rect id="main_14" x="18.789" y="36.218" width="20.062" height="28.624" />
      <rect id="main_15" x="20.731" y="38.27" width="16.177" height="24.522" />
      <line id="scnd_11" fill="none" stroke-width="0.5" x1="20.731" y1="38.27" x2="20.731" y2="62.792" />
      <line id="scnd_12" fill="none" stroke-width="0.5" x1="20.731" y1="38.27" x2="36.908" y2="38.27" />
      <line id="scnd_13" fill="none" stroke-width="0.5" x1="36.908" y1="62.792" x2="36.908" y2="38.27" />
      <line id="scnd_15" fill="none" stroke-width="0.5" x1="36.908" y1="62.792" x2="20.731" y2="62.792" />
      <line id="scnd_15" fill="none" stroke-width="0.5" x1="18.789" y1="36.218" x2="18.789" y2="64.842" />
      <line id="scnd_16" fill="none" stroke-width="0.5" x1="18.789" y1="36.218" x2="38.851" y2="36.218" />
      <rect id="main_16" x="91.604" y="23.027" width="41.836" height="38.257" />
      <rect id="main_17" x="133.439" y="12.568" width="26.146" height="58.625" />
      <rect id="main_18" y="71.193" width="167.341" height="8.807" />
      <rect id="scnd_18" x="60.228" y="56.33" width="73.212" height="14.863" />

      <rect id="main_19" x="59.401" y="18.348" width="32.202" height="48.991" />
      <rect id="main_20" x="89.8" y="56.33" width="40.887" height="14.863" />
      <rect id="main_21" x="91.742" y="58.382" width="37.002" height="10.762" />
      <line id="scnd_21" fill="none" stroke-width="0.5" x1="91.742" y1="58.382" x2="91.742" y2="69.144" />
      <line id="scnd_22" fill="none" stroke-width="0.5" x1="91.742" y1="58.382" x2="128.744" y2="58.382" />
      <line id="scnd_23" fill="none" stroke-width="0.5" x1="128.744" y1="69.144" x2="128.744" y2="58.382" />
      <line id="scnd_24" fill="none" stroke-width="0.5" x1="89.8" y1="56.33" x2="89.8" y2="71.193" />
      <line id="scnd_25" fill="none" stroke-width="0.5" x1="89.8" y1="56.33" x2="130.687" y2="56.33" />
      <rect id="main_22" x="159.586" y="23.853" width="2.753" height="26.973" />
      <rect id="main_23" x="162.339" y="23.853" width="5.23" height="26.973" />
      <rect id="main_24" x="166.658" y="27.339" width="5.222" height="20" />
      <rect id="main_25" x="171.88" y="24.339" width="5.223" height="26" />
      <rect id="main_26" x="132.982" width="26.787" height="4.588" />
    </defs>
    <g :visibility="fState[0]">
      <use href="#main_1" fill="url(#SCND_SVGID_1_)" />
      <use href="#main_2" fill="url(#SCND_SVGID_2_)" />
      <use href="#main_3" fill="url(#SCND_SVGID_3_)" />
      <use href="#main_4" fill="url(#SCND_SVGID_4_)" />
      <use href="#main_5" fill="url(#SCND_SVGID_5_)" />
      <use href="#scnd_5" fill="#4A4A4A" />
      <use href="#main_6" fill="url(#SCND_SVGID_6_)" />
      <use href="#main_7" fill="url(#SCND_SVGID_7_)" />
      <use href="#main_8" fill="url(#SCND_SVGID_8_)" />
      <use href="#main_9" fill="url(#SCND_SVGID_9_)" />
      <use href="#main_10" fill="url(#SCND_SVGID_10_)" />
      <use href="#main_11" fill="url(#SCND_SVGID_11_)" />
      <use href="#main_12" fill="url(#SCND_SVGID_12_)" />
      <use href="#main_13" fill="url(#SCND_SVGID_13_)" />
      <use href="#scnd_6" fill="#4A4A4A" />
      <use href="#main_14" fill="url(#SCND_SVGID_14_)" />
      <use href="#main_15" fill="url(#SCND_SVGID_15_)" />
      <use href="#scnd_11" stroke="#FFFFFF" />
      <use href="#scnd_12" stroke="#FFFFFF" />
      <use href="#scnd_13" stroke="#B2B2B2" />
      <use href="#scnd_14" stroke="#333333" />
      <use href="#scnd_15" stroke="#4D4D4D" />
      <use href="#scnd_16" stroke="#4D4D4D" />
      <use href="#main_16" fill="url(#SCND_SVGID_16_)" />
      <use href="#main_17" fill="url(#SCND_SVGID_17_)" />
      <use href="#main_18" fill="url(#SCND_SVGID_18_)" />
      <use href="#scnd_18" fill="#4A4A4A" />

      <use href="#main_19" fill="url(#SCND_SVGID_19_)" />
      <use href="#main_20" fill="url(#SCND_SVGID_20_)" />
      <use href="#main_21" fill="url(#SCND_SVGID_21_)" />
      <use href="#scnd_21" stroke="#4D4D4D" />
      <use href="#scnd_22" stroke="#4D4D4D" />
      <use href="#scnd_23" stroke="#333333" />
      <use href="#scnd_24" stroke="#F2F2F2" />
      <use href="#scnd_25" stroke="#F2F2F2" />
      <use href="#main_22" fill="url(#SCND_SVGID_22_)" />
      <use href="#main_23" fill="url(#SCND_SVGID_23_)" />
      <use href="#main_24" fill="url(#SCND_SVGID_24_)" />
      <use href="#main_25" fill="url(#SCND_SVGID_25_)" />
      <use href="#main_26" fill="url(#SCND_SVGID_26_)" />
    </g>
    <!-- red -->
    <g :visibility="fState[1]">
      <use href="#main_1" fill="url(#red_1_)" />
      <use href="#main_2" fill="url(#red_2_)" />
      <use href="#main_3" fill="url(#red_3_)" />
      <use href="#main_4" fill="url(#red_4_)" />
      <use href="#main_5" fill="url(#red_5_)" />
      <use href="#scnd_5" fill="#4A0000" />
      <use href="#main_6" fill="url(#red_6_)" />
      <use href="#main_7" fill="url(#red_7_)" />
      <use href="#main_8" fill="url(#red_8_)" />
      <use href="#main_9" fill="url(#red_9_)" />
      <use href="#main_10" fill="url(#red_10_)" />
      <use href="#main_11" fill="url(#red_11_)" />
      <use href="#main_12" fill="url(#red_12_)" />
      <use href="#main_13" fill="url(#red_13_)" />
      <use href="#scnd_6" fill="#4A0000" />
      <use href="#main_14" fill="url(#red_14_)" />
      <use href="#main_15" fill="url(#red_15_)" />
      <use href="#scnd_11" stroke="#FF0000" />
      <use href="#scnd_12" stroke="#FF0000" />
      <use href="#scnd_13" stroke="#B20000" />
      <use href="#scnd_14" stroke="#330000" />
      <use href="#scnd_15" stroke="#4D0000" />
      <use href="#scnd_16" stroke="#4D0000" />
      <use href="#main_16" fill="url(#red_16_)" />
      <use href="#main_17" fill="url(#red_17_)" />
      <use href="#main_18" fill="url(#red_18_)" />
      <use href="#scnd_18" fill="#4A0000" />

      <use href="#main_19" fill="url(#red_19_)" />
      <use href="#main_20" fill="url(#red_20_)" />
      <use href="#main_21" fill="url(#red_21_)" />
      <use href="#scnd_21" stroke="#4D0000" />
      <use href="#scnd_22" stroke="#4D0000" />
      <use href="#scnd_23" stroke="#330000" />
      <use href="#scnd_24" stroke="#F20000" />
      <use href="#scnd_25" stroke="#F20000" />
      <use href="#main_22" fill="url(#red_22_)" />
      <use href="#main_23" fill="url(#red_23_)" />
      <use href="#main_24" fill="url(#red_24_)" />
      <use href="#main_25" fill="url(#red_25_)" />
      <use href="#main_26" fill="url(#red_26_)" />
    </g>
    <!-- yellow -->
    <g :visibility="fState[2]">
      <use href="#main_1" fill="url(#yellow_1_)" />
      <use href="#main_2" fill="url(#yellow_2_)" />
      <use href="#main_3" fill="url(#yellow_3_)" />
      <use href="#main_4" fill="url(#yellow_4_)" />
      <use href="#main_5" fill="url(#yellow_5_)" />
      <use href="#scnd_5" fill="#4A4A00" />
      <use href="#main_6" fill="url(#yellow_6_)" />
      <use href="#main_7" fill="url(#yellow_7_)" />
      <use href="#main_8" fill="url(#yellow_8_)" />
      <use href="#main_9" fill="url(#yellow_9_)" />
      <use href="#main_10" fill="url(#yellow_10_)" />
      <use href="#main_11" fill="url(#yellow_11_)" />
      <use href="#main_12" fill="url(#yellow_12_)" />
      <use href="#main_13" fill="url(#yellow_13_)" />
      <use href="#scnd_6" fill="#4A4A00" />
      <use href="#main_14" fill="url(#yellow_14_)" />
      <use href="#main_15" fill="url(#yellow_15_)" />
      <use href="#scnd_11" stroke="#FFFF00" />
      <use href="#scnd_12" stroke="#FFFF00" />
      <use href="#scnd_13" stroke="#B2B200" />
      <use href="#scnd_14" stroke="#333300" />
      <use href="#scnd_15" stroke="#4D4D00" />
      <use href="#scnd_16" stroke="#4D4D00" />
      <use href="#main_16" fill="url(#yellow_16_)" />
      <use href="#main_17" fill="url(#yellow_17_)" />
      <use href="#main_18" fill="url(#yellow_18_)" />
      <use href="#scnd_18" fill="#4A4A00" />

      <use href="#main_19" fill="url(#yellow_19_)" />
      <use href="#main_20" fill="url(#yellow_20_)" />
      <use href="#main_21" fill="url(#yellow_21_)" />
      <use href="#scnd_21" stroke="#4D4D00" />
      <use href="#scnd_22" stroke="#4D4D00" />
      <use href="#scnd_23" stroke="#333300" />
      <use href="#scnd_24" stroke="#F2F200" />
      <use href="#scnd_25" stroke="#F2F200" />
      <use href="#main_22" fill="url(#yellow_22_)" />
      <use href="#main_23" fill="url(#yellow_23_)" />
      <use href="#main_24" fill="url(#yellow_24_)" />
      <use href="#main_25" fill="url(#yellow_25_)" />
      <use href="#main_26" fill="url(#yellow_26_)" />
    </g>
    <!-- green -->
    <g :visibility="fState[3]">
      <use href="#main_1" fill="url(#green_1_)" />
      <use href="#main_2" fill="url(#green_2_)" />
      <use href="#main_3" fill="url(#green_3_)" />
      <use href="#main_4" fill="url(#green_4_)" />
      <use href="#main_5" fill="url(#green_5_)" />
      <use href="#scnd_5" fill="#4A804A" />
      <use href="#main_6" fill="url(#green_6_)" />
      <use href="#main_7" fill="url(#green_7_)" />
      <use href="#main_8" fill="url(#green_8_)" />
      <use href="#main_9" fill="url(#green_9_)" />
      <use href="#main_10" fill="url(#green_10_)" />
      <use href="#main_11" fill="url(#green_11_)" />
      <use href="#main_12" fill="url(#green_12_)" />
      <use href="#main_13" fill="url(#green_13_)" />
      <use href="#scnd_6" fill="#4A804A" />
      <use href="#main_14" fill="url(#green_14_)" />
      <use href="#main_15" fill="url(#green_15_)" />
      <use href="#scnd_11" stroke="#FFFFFF" />
      <use href="#scnd_12" stroke="#FFFFFF" />
      <use href="#scnd_13" stroke="#B2B2B2" />
      <use href="#scnd_14" stroke="#333333" />
      <use href="#scnd_15" stroke="#4D4D4D" />
      <use href="#scnd_16" stroke="#4D4D4D" />
      <use href="#main_16" fill="url(#green_16_)" />
      <use href="#main_17" fill="url(#green_17_)" />
      <use href="#main_18" fill="url(#green_18_)" />
      <use href="#scnd_18" fill="#4A804A" />

      <use href="#main_19" fill="url(#green_19_)" />
      <use href="#main_20" fill="url(#green_20_)" />
      <use href="#main_21" fill="url(#green_21_)" />
      <use href="#scnd_21" stroke="#4D4D4D" />
      <use href="#scnd_22" stroke="#4D4D4D" />
      <use href="#scnd_23" stroke="#333333" />
      <use href="#scnd_24" stroke="#F2F2F2" />
      <use href="#scnd_25" stroke="#F2F2F2" />
      <use href="#main_22" fill="url(#green_22_)" />
      <use href="#main_23" fill="url(#green_23_)" />
      <use href="#main_24" fill="url(#green_24_)" />
      <use href="#main_25" fill="url(#green_25_)" />
      <use href="#main_26" fill="url(#green_26_)" />
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "scnd",
  mixins: [MixinStates],
  computed: {
    fState: function () {
      let states = ["hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden", "hidden"];
      if (this.binary) {
        if (this.value) {
          states[3] = "visible"
        }
        else {
          states[2] = "visible"
        }
      } else
        this.stateSwitch(states, this.value)

      return states;
    }
  },
};
</script>
